import Noty from "noty";
import {hash, i18n, lang} from './../fancyBoxConfig';
const $ = require('jquery');
global.jQuery = $;

require('@fancyapps/fancybox');

$.fancybox.defaults.hash = hash;
$.fancybox.defaults.i18n.ru = i18n.ru;
$.fancybox.defaults.lang = lang;

export function dialog(obj){
    $.fancybox.open(obj);
}

export function notice(message, isError) {
    new Noty({
        type: isError ? 'warning' : 'alert',
        text: message,
        theme: "light",
        timeout: 3000
    }).show();
}

export function fancyConfirm(opts) {
    opts = $.extend(
        true, {
            title: "Are you sure?",
            message: "",
            okButton: "OK",
            noButton: "Cancel",
            callback: $.noop
        },
        opts || {}
    );
    $.fancybox.open({
        type: "html",
        src: `<div class="main-modal">
                <div class="delete-modal">
                    <div class="delete-modal-heading mb-3">
                        <h1 class="main-heading pr-5">${opts.title}</h1>
                    </div>
                    <div class="delete-modal-body row">
                        <p>${opts.message}</p>
                        <div class="col-sm-6 mb-3 mb-sm-0">
                            <button class="btn btn-red w-100" data-value="1" data-fancybox-close>${opts.okButton}</button>
                        </div>
                        <div class="col-sm-6">
                            <button class="btn btn-grey w-100" data-fancybox-close>${opts.noButton}</button>
                        </div>
                    </div>
                </div>
            </div>`,
        opts: {
            animationDuration: 350,
            animationEffect: "material",
            modal: true,
            baseTpl: '<div class="fancybox-container fc-container" role="dialog" tabindex="-1">' +
                '<div class="fancybox-bg"></div>' +
                '<div class="fancybox-inner">' +
                '<div class="fancybox-stage"></div>' +
                "</div>" +
                "</div>",
            afterClose: function (instance, current, e) {
                let button = e ? e.target || e.currentTarget : null;
                let value = button ? $(button).data("value") : 0;
                opts.callback(value);
            }
        }
    });
}

export function alertMessage(title, message, modalSize) {
    if (!modalSize) {
        modalSize = 'modal-sm';
    }

    $.fancybox.open({
        type: "html",
        src: `<div>
                <div class="login-page-block call-modal">
                    <div class="login-page-block-login">
                        <svg class="icon icon-waves"><use xlink:href="#icon-waves"></use></svg>
                        <h1 class="main-heading">${title}</h1>
                        ${message}
                    </div>
                </div>
            </div>`
        });
}

export function showModal(body, callback, afterClose, type) {
    $.fancybox.open({
        type: type? type : "html",
        src: body,
        opts: {
            afterShow: function (instance, current) {
                if(callback){
                    callback(instance, current);
                }
            },
            afterClose: function () {
                if(afterClose){
                    afterClose();
                }
            }
        }
    });
}

export function closeModals(all) {
    $.fancybox.close(all)
}